import { component } from 'picoapp'
import { zelektor, loopify, toggleDisplay } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { item: items = [] } = zelektor(node)


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    loopify(items).forEach(item => {
        const { title, content } = zelektor(item)

        title.addEventListener('click', () => {
            toggleItem(title, content)
        })
    })


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function toggleItem(title, content) {
        title.classList.toggle('is-open')
        toggleDisplay(content)
    }
})